import React, { useState, useEffect } from "react";
import {useDispatch, useSelector} from 'react-redux';

import moment from "moment";
import "moment/locale/es"; // without this line it didn't work

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { EmpresaAfiliadoItemAlta } from "./EmpresaAfiliadoItemAlta";
import { empresaPreAfiliadoInsertStart } from "../../actions/empresasPreafiliado";
import EmpresaAltaModal from "../empresas/EmpresaAltaModal";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export const NuevaEmpresaPreAfiliado = ({ abrirModal, setAbrirModal }) => {
  // const [empresaSeleccionada, setEmpresaSeleccionada] = React.useState(false);
  const [empresaAfiliado, setEmpresaAfiliado] = React.useState({
    idEmpresa: 0,
    idEmpresaAfiliado: null,
    fechaDesde: moment().toDate(),
    fechaHasta: null,
    empresa: {},
  });
  const [altaModal, setAltaModal] = useState(false);
  const { empresaABM } = useSelector((state) => state.empresas);

  const dispatch = useDispatch();

  useEffect(() => {
    setAbrirModal(abrirModal);
  }, [abrirModal, setAbrirModal]);

  const handleClose = (e) => {
    e.preventDefault();
    setAbrirModal(false);
  };

  const handleAdd = (e) => {
    e.preventDefault();
    if(empresaAfiliado){
        setAbrirModal(false);
        //console.log('alta',empresaAfiliado);
        dispatch(empresaPreAfiliadoInsertStart(empresaAfiliado));
    }
  };
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="titulo"
        open={abrirModal}
        fullWidth={true}
        maxWidth={"md"}
      >
        <DialogTitle id="tituloModal" onClose={handleClose}>
          Nueva Empresa
          <Button style={{float:"right", marginRight:"3rem"}} color='primary' variant='contained' onClick={()=>setAltaModal(true)} disabled={true}>+ AGREGAR NUEVA EMPRESA</Button>
        </DialogTitle>
        <DialogContent dividers>
          {/* <Typography gutterBottom>
            Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
            dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta
            ac consectetur ac, vestibulum at eros.
          </Typography> */}
          <EmpresaAfiliadoItemAlta
            empresaAfiliado={empresaAfiliado}
            setEmpresaAfiliado={setEmpresaAfiliado}
          />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleAdd} color="primary">
            Guardar
          </Button>
        </DialogActions>
        <EmpresaAltaModal item={empresaABM} abrirModal={altaModal} setAbrirModal={setAltaModal} />
      </Dialog>
    </div>
  );
};
